import React, { useEffect, useState, lazy, Suspense } from 'react';
import Spinner from './Spinner';
import './Buscador.css';
import { getDatosInicio } from './Llamadas';


const Buscador = lazy(() => import('./Buscador'));

export default function App() {
    const [datos, setDatos] = useState(null);

    useEffect(() => {
        getDatosInicio().then(setDatos);
    }, []);

    const renderContenido = () => {
        if (!datos) {
            // Muestra solo el spinner mientras se cargan los datos
            return (
                <Spinner />
            );
        }

        const { listaAeropuertos, variables, configuraciones, traducciones, areas, areasOriginales } = datos;


        return (
            <Suspense fallback={<Spinner />}>
                <Buscador listaAeropuertosAPI={listaAeropuertos} variables={variables} configuraciones={configuraciones} traducciones={traducciones} areas={areas} areasOriginales={areasOriginales}></Buscador>

            </Suspense>
        );
    };

    return renderContenido();
}
